module.exports = __webpack_public_path__ + "img/48.10.pH.c273412d.png";